import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';

export default function AuthInitializer({ children }) {
  const initialize = useAuthStore((state) => state.initialize);
  const setHasHydrated = useAuthStore((state) => state.setHasHydrated);
  const _hasHydrated = useAuthStore((state) => state._hasHydrated);

  useEffect(() => {
    // Initialize auth from localStorage
    initialize();
    setHasHydrated(true);
  }, [initialize, setHasHydrated]);

  // Wait for hydration to complete before rendering children
  // This prevents flash of unauthenticated content
  if (!_hasHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background dark:bg-background-dark">
        <div className="text-text-secondary dark:text-text-secondary-dark">Loading...</div>
      </div>
    );
  }

  return children;
}
